module.exports = __webpack_public_path__ + "routes/home/ihub2_photo.png?2eff4b8f";


//////////////////
// WEBPACK FOOTER
// ./routes/home/ihub2_photo.png
// module id = 1465
// module chunks = 0